import React from 'react';
import { Stack, Text } from '@mantine/core';
import { DeliveryEventVendorDetailsUpcoming } from '../types';

export const DeliveryUpcomingCapacity: React.FC<{
  event: DeliveryEventVendorDetailsUpcoming;
}> = ({ event }) => {
  const maxCapacity = event?.configuredCapacity;
  return (
    <Stack gap="xs" p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
      <Text>
        Max capacity:{' '}
        {!!maxCapacity ? (
          <>
            <Text span fw="bold">
              {maxCapacity}
            </Text>{' '}
            items
          </>
        ) : (
          <Text span fw="bold">
            No capacity restrictions
          </Text>
        )}
      </Text>
    </Stack>
  );
};
